import { environmentConfig } from './environment';

export default environmentConfig;
